import React from "react";
import { FaChartPie } from "react-icons/fa";
import ResourceQuotaIndicator from "../components/ResourceQuotaIndicator";
import { useAppTheme } from "../context/AppThemeContext";

const PLAN_RESOURCES = [
  { key: "students", label: "Students" },
  { key: "teachers", label: "Teachers" },
  { key: "classes", label: "Classes" },
  { key: "subjects", label: "Subjects" },
  { key: "timetableSlots", label: "Timetable slots" },
  { key: "exams", label: "Exams" },
  { key: "feeRecords", label: "Fee records" },
  { key: "parents", label: "Parents" },
  { key: "users", label: "Users" },
  { key: "notifications", label: "Notifications" },
];

const PlanUsage = () => {
  const { isDarkMode } = useAppTheme();

  return (
    <div className={isDarkMode ? "min-h-full bg-slate-950 p-4 text-slate-100 sm:p-6 lg:p-8" : "min-h-full bg-slate-50 p-4 text-slate-900 sm:p-6 lg:p-8"}>
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex items-start gap-4">
          <span className={isDarkMode ? "grid h-11 w-11 place-items-center rounded-xl bg-cyan-950 text-cyan-300" : "grid h-11 w-11 place-items-center rounded-xl bg-cyan-100 text-cyan-700"}>
            <FaChartPie aria-hidden="true" />
          </span>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-cyan-600">Subscription</p>
            <h1 className="mt-1 text-2xl font-black sm:text-3xl">Plan usage</h1>
            <p className={isDarkMode ? "mt-2 text-sm text-slate-400" : "mt-2 text-sm text-slate-600"}>Review the remaining capacity on your current school plan.</p>
          </div>
        </div>
        <ResourceQuotaIndicator resources={PLAN_RESOURCES} />
      </div>
    </div>
  );
};

export default PlanUsage;
